// The sign-in page: Google (when the site offers it) or email and password, both through the
// hospital's identity provider. Nobody sees patients before signing in.

import { useQuery } from '@tanstack/react-query';
import { fetchProviders, signInUrl } from '../api.ts';
import { SignOutButton, Wordmark } from '../components/Layout.tsx';
import { GoogleIcon, ShieldIcon } from '../icons.tsx';

export function SignInPage() {
  const providers = useQuery({ queryKey: ['providers'], queryFn: fetchProviders, retry: false });
  return (
    <div className="signin">
      <div className="signin-card">
        <Wordmark />
        <h1>Sign in to the ED board</h1>
        <p className="muted">Every critical moment, clarity.</p>
        <div className="signin-actions">
          {providers.data?.google === true && (
            <a className="btn btn-google" href={signInUrl('google')}>
              <GoogleIcon /> Continue with Google
            </a>
          )}
          <a className="btn btn-primary btn-wide" href={signInUrl()}>
            Sign in with email
          </a>
        </div>
        <p className="signin-note">
          <ShieldIcon size={16} /> Access by invitation only. Simulated demonstration data; no real
          patients.
        </p>
      </div>
    </div>
  );
}

export function NoAccessPage() {
  return (
    <div className="signin">
      <div className="signin-card">
        <Wordmark />
        <h1>You are signed in, but have no access yet</h1>
        <p className="muted">
          Your account needs an ED role and a site. Ask a site administrator to add you, then sign
          in again.
        </p>
        <div className="signin-actions">
          <SignOutButton className="btn btn-primary btn-wide" />
        </div>
      </div>
    </div>
  );
}
